module.exports = __webpack_public_path__ + "static/media/handmobile.2335a299.png";